import { ButtonGroup } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import "./LinkPayment.css";

const existinSessionKey = "MCR_existingSession"
const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

const Puller = styled(Box)(() => ({
    width: 30,
    height: 6,
    backgroundColor: grey[400],
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
}));

export default function LinkPayment() {
    const { t, i18n } = useTranslation()
    const [open, setOpen] = useState(false)
    const existingSession = typeof localStorage !== 'undefined' && localStorage.getItem(existinSessionKey) === "true"

    useEffect(() => {
        if (typeof localStorage !== 'undefined') {
            if (!existingSession) {
                setOpen(true)
                localStorage.setItem(existinSessionKey, "true")
            } else {
                setOpen(false)
            }
        }
    }, [])

    return (
        <SwipeableDrawer
            anchor="bottom"
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            disableSwipeToOpen={false}
            disableBackdropTransition={!iOS}
            disableDiscovery={iOS}
        >
            <Container className="drawer-container" maxWidth="xs">
                <Puller />
                <ButtonGroup size='small' variant='text' className="drawer-toggle-language" aria-label="Language selection">
                    <Button onClick={() => i18n.changeLanguage('fr')} color={(i18n.resolvedLanguage === 'fr') ? 'secondary' : 'primary'}>FR</Button>
                    <Button onClick={() => i18n.changeLanguage('en')} color={i18n.resolvedLanguage === 'en' ? 'secondary' : 'primary'}>EN</Button>
                </ButtonGroup>
                <Typography variant="h6" color="primary" marginLeft={0} marginBottom={4}>{t("link-payment.title")}</Typography>
                <Typography variant="subtitle1" marginBottom={4}>{t("link-payment.body")}</Typography>
                <Button className="drawer-button" variant="contained" color="secondary" size="large" fullWidth onClick={() => setOpen(false)}>{t("link-payment.cancel-action")}</Button>
                <Button className="drawer-button" variant="text" color="secondary" target="_blank" onClick={() => setOpen(false)} href="https://apps.total-ev-charge.com/charge-points">{t("link-payment.confirm-action")}</Button>
            </Container>
        </SwipeableDrawer>
    );
}